// extracted by mini-css-extract-plugin
module.exports = {"note":"sCnDY2","noteViewport":"rzu4Si","button":"yoQE_e","body":"_6FtuM","icon":"bqcF4y"};